module.exports = __webpack_public_path__ + "img/dropdown.7cfd9475.svg";